export const agreementHtml = `
<p>ПОЛЬЗОВАТЕЛЬСКОЕ СОГЛАШЕНИЕ</p>
<p>1. ОБЩИЕ ПОЛОЖЕНИЯ</p>
<p>1.1. Настоящее Пользовательское соглашение (далее — «Соглашение») регулирует отношения между Индивидуальным предпринимателем Осиповым Георгием Константиновичем (ИНН 226815206066, ОГРНИП 325220200123122), далее — «Администрация» или «Оператор», и Пользователем сервиса «Авигатор».</p>
<p>1.2. Сервис доступен через Telegram-бот @avigatr_bot, Telegram Mini App https://avigator.duckdns.org и веб-сайт https://avigator.duckdns.org/about.html.</p>
<p>1.3. Использование Сервиса означает принятие условий настоящего Соглашения. Если Пользователь не согласен с условиями, он обязан прекратить использование Сервиса.</p>
<p>1.4. Администрация вправе изменять Соглашение, публикуя новую редакцию в Сервисе. Права Пользователей, уже оплативших доступ, не могут быть произвольно изменены в одностороннем порядке в ущерб уже исполненным обязательствам.</p>
<p>2. ПРЕДМЕТ СОГЛАШЕНИЯ</p>
<p>2.1. Администрация предоставляет Пользователю доступ к функционалу Сервиса, предназначенному для мониторинга и сбора информации об объявлениях продавцов, размещённых на Авито, на основании заданных Пользователем поисковых параметров.</p>
<p>2.2. Функциональность Сервиса зависит от выбранного тарифа. Администрация вправе изменять перечень поддерживаемых функций и технические параметры для будущих периодов доступа, если иное не предусмотрено условиями оплаченного тарифа.</p>
<p>2.3. Сервис работает с информацией, доступной из сторонних интернет-ресурсов. Администрация не гарантирует постоянную доступность, полноту или неизменность данных сторонних площадок.</p>
<p>3. ТАРИФЫ И ДОСТУП</p>
<p>3.1. Доступ предоставляется на месячной основе по следующим тарифам:</p>
<table>
<colgroup>
<col style="width: 25%" />
<col style="width: 25%" />
<col style="width: 25%" />
<col style="width: 25%" />
</colgroup>
<thead>
<tr class="header">
<th>Тариф</th>
<th>Цена</th>
<th>Поисковые ссылки</th>
<th>Скорость обнаружения</th>
</tr>
</thead>
<tbody>
<tr class="odd">
<td>START</td>
<td>790 ₽/мес.</td>
<td>1</td>
<td>⚡ стандартная</td>
</tr>
<tr class="even">
<td>PRO</td>
<td>1 990 ₽/мес.</td>
<td>2</td>
<td>⚡⚡ высокая</td>
</tr>
<tr class="odd">
<td>EXPERT</td>
<td>3 990 ₽/мес.</td>
<td>3</td>
<td>⚡⚡⚡ максимальная</td>
</tr>
</tbody>
</table>
<p>Скорость обнаружения зависит от тарифа: чем больше молний, тем чаще проверяются поисковые ссылки и тем раньше приходит уведомление о новом объявлении. Точная периодичность проверок не гарантируется: она зависит от работы Avito, доступности сети и нагрузки на Сервис.</p>
<h2 id="start-790-мес.">START — 790 ₽/мес.</h2>
<ul>
<li><p>1 поисковая ссылка</p></li>
<li><p>скорость обнаружения — ⚡ стандартная</p></li>
<li><p>уведомления в Telegram</p></li>
<li><p>доступ к Telegram Mini App</p></li>
</ul>
<h2 id="pro-1-990-мес.">PRO — 1 990 ₽/мес.</h2>
<ul>
<li><p>2 поисковые ссылки</p></li>
<li><p>скорость обнаружения — ⚡⚡ высокая</p></li>
<li><p>все функции START</p></li>
<li><p>фильтр продавцов</p></li>
<li><p>скрытие продавцов</p></li>
</ul>
<h2 id="expert-3-990-мес.">EXPERT — 3 990 ₽/мес.</h2>
<ul>
<li><p>3 поисковые ссылки</p></li>
<li><p>скрытие продавцов</p></li>
<li><p>скорость обнаружения — ⚡⚡⚡ максимальная</p></li>
<li><p>все функции PRO</p></li>
<li><p>групповые уведомления</p></li>
</ul>
<p>3.2. Бесплатный пробный период предоставляется сроком 48 часов один раз для одного Пользователя.</p>
<p>3.3. Пробный период активируется через интерфейс Telegram-бота после нажатия соответствующей кнопки в меню, в том числе после добавления поискового запроса, если такая возможность предусмотрена интерфейсом.</p>
<p>3.4. Администрация вправе устанавливать технические ограничения пробного периода для предотвращения повторного получения бесплатного доступа.</p>
<p>3.5. Стоимость тарифов указана в российских рублях. НДС не предъявляется в связи с применением Оператором упрощённой системы налогообложения.</p>
<p>4. ПРАВА И ОБЯЗАННОСТИ СТОРОН</p>
<p>4.1. Администрация обязуется:</p>
<ul>
<li><p>поддерживать работоспособность Сервиса в пределах технически возможного;</p></li>
<li><p>предоставлять доступ к функционалу согласно выбранному тарифу;</p></li>
<li><p>обрабатывать персональные данные в соответствии с Политикой конфиденциальности;</p></li>
<li><p>рассматривать обращения Пользователя по вопросам работы Сервиса.</p></li>
</ul>
<p>4.2. Администрация вправе:</p>
<ul>
<li><p>приостанавливать работу для профилактики и технических работ;</p></li>
<li><p>ограничивать доступ при нарушении Соглашения;</p></li>
<li><p>изменять интерфейс и отдельные функции Сервиса;</p></li>
<li><p>принимать технические меры для защиты Сервиса от злоупотреблений.</p></li>
</ul>
<p>4.3. Пользователь обязуется:</p>
<ul>
<li><p>использовать Сервис законно;</p></li>
<li><p>не вмешиваться в работу Сервиса и его инфраструктуру;</p></li>
<li><p>не пытаться получать исходный код или обходить технические ограничения;</p></li>
<li><p>не использовать Сервис для незаконной деятельности;</p></li>
<li><p>самостоятельно соблюдать правила и условия использования сторонних ресурсов, данные которых он получает через Сервис.</p></li>
</ul>
<p>5. ОТВЕТСТВЕННОСТЬ</p>
<p>5.1. Администрация не отвечает за содержание, достоверность, полноту и актуальность информации, размещённой на сторонних интернет-площадках.</p>
<p>5.2. Администрация не гарантирует непрерывную работу сторонних ресурсов, включая Авито, Telegram, хостинг, сети связи и иные системы, от которых зависит работа Сервиса.</p>
<p>5.3. Пользователь самостоятельно отвечает за действия, совершённые им с использованием полученной через Сервис информации.</p>
<p>5.4. Администрация не несёт ответственности за упущенную выгоду и косвенные убытки, если иное прямо не предусмотрено обязательными нормами законодательства Российской Федерации.</p>
<p>5.5. Ограничения ответственности не применяются в той части, в которой они не допускаются законодательством Российской Федерации.</p>
<p>6. ИНТЕЛЛЕКТУАЛЬНАЯ СОБСТВЕННОСТЬ</p>
<p>6.1. Исключительные права на программный код, интерфейс, дизайн, базы данных и иные охраняемые результаты интеллектуальной деятельности, относящиеся к Сервису «Авигатор», принадлежат Оператору либо используются им на законных основаниях.</p>
<p>6.2. Пользователь не получает права копировать, распространять, декомпилировать, модифицировать или иным образом использовать программные компоненты Сервиса за пределами предоставленного права пользования.</p>
<p>7. ПЕРСОНАЛЬНЫЕ ДАННЫЕ</p>
<p>7.1. Обработка персональных данных регулируется Политикой конфиденциальности, являющейся неотъемлемой частью настоящего Соглашения.</p>
<p>7.2. В случаях, когда требуется отдельное согласие на обработку персональных данных, оно предоставляется Пользователем посредством соответствующего активного действия в интерфейсе Сервиса.</p>
<p>8. ПРЕКРАЩЕНИЕ ДОСТУПА</p>
<p>8.1. Пользователь вправе прекратить использование Сервиса в любое время.</p>
<p>8.2. Администрация вправе ограничить или прекратить доступ при существенном нарушении Пользователем условий Соглашения, требований законодательства или попытках вмешательства в работу Сервиса.</p>
<p>8.3. Прекращение доступа не освобождает стороны от обязательств, возникших до момента прекращения.</p>
<p>9. РАЗРЕШЕНИЕ СПОРОВ</p>
<p>9.1. Стороны стремятся разрешать споры путём переговоров и направления претензии.</p>
<p>9.2. Споры рассматриваются в порядке и по подсудности, установленным законодательством Российской Федерации. Условия настоящего раздела не ограничивают права потребителя на обращение в суд, предоставленные ему законом.</p>
<p>10. РЕКВИЗИТЫ</p>
<p>ИП Осипов Георгий Константинович</p>
<p>ИНН: 226815206066</p>
<p>ОГРНИП: 325220200123122</p>
<p>Email: ra_radar@bk.ru</p>
<p>Telegram поддержки: @pepperchanin</p>

`;
